<template>
        <div>
            <div class="c"></div>
            <div id="bd">
                <div class="" id="whous">
                    <img src="../assets/Images/zwyth-banner.png">
                    <img src="../assets/Images/zwyth_01.png">  
                    <div class="tit-i" id="tysfrz">
                        <h3>统一身份认证</h3>
                        <h5><span>Unified identity authentication </span></h5>
                    </div>
                    <div class="zh-linebox">
                        <div class="imgleft">
                            <img src="../assets/Images/zwyth_02.png">
                        </div>
                        <div class="zh-content ">
                            <h3>一次认证，全网通办</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p style="width:70%">
                                通过“省”统一身份认证平台，对接国家基于自然人信息与法人单位信息等国家认证资源的全国统一身份认证系统。实现中心各业务渠道与“市”政务服务网“一次认证，全网通办”。
                            </p>
                        </div>
                    </div>
                        <div class="tit-i" id="zwfwhcp">
                        <h3>政务服务“好差评”</h3>
                        <h5><span>government service evaluation</span></h5>
                        </div>
                    <div class="zh-linebox bg-gray">                       
                        <div class="zh-content content-left" style="padding-top:140px;">
                            <h3>转变政府职能，创新行政方式，提高行政效能</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p>
                                搭建公积金线上、线下政务服务“好差评”管理体系，各级服务机构（含大厅、中心、窗口等）、各类服务平台（含业务系统、互联网服务端、移动互联网服务端、自助服务端等）全部开展“好差评”，线上线下全面融合，实现政务服务事项全覆盖、评价对象全覆盖、服务渠道全覆盖。
                            </p>
                        </div>
                        <div class="imgright" style="float:right;">
                            <img  src="../assets/Images/zwyth_03.png">
                        </div>
                    </div>
                     <div class="tit-i" id="dzpj">
                        <h3>电子（印章）票据</h3>
                        <h5><span>E-SEAL BILL</span></h5>
                     </div>                   
                    <div class="zh-linebox">
                        <div class="imgleft">
                            <img src="../assets/Images/zwyth_04.png">
                        </div>
                        <div class="zh-content ">
                            <h3>票据，档案电子化</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p style="width:70%">
                                 依托“省”电子印章制章系统，为公积金线上、线下服务渠道（含业务系统、互联网服务端、移动互联网服务端、自助服务端等）政务服务事项办理，提供票据、档案电子化可信能力。
                            </p>
                        </div>
                    </div>
                     <div class="tit-i" id="ydfx">
                        <h3>政务数据共享</h3>
                        <h5><span>Government data sharing</span></h5>
                     </div>                 
                    <div class="zh-linebox bg-gray">
                        <div class="zh-content content-left" style="padding-top:140px;">
                            <h3>数"智"化，数"治"化</h3>
                            <!-- <div class="content-subtitle">人脸识别、手写板签名</div> -->
                            <p>
                                依托“市大数据中心”、“省一体化平台”以及“住建部数据共享平台”的政务信息互通，提升公积金政务服务数"智"化办理效率，加强公积金数"治"化运管能力，全面推动"一件事，一次办"的政务服务理念。
                            </p>
                        </div>
                        <div class="imgright" style="float:right;">
                            <img  src="../assets/Images/zwyth_05.png">
                        </div>
                    </div>
                    <!--产品-->
                    <div class="wp">
                        <div class="tit-i">
                            <h3>产品</h3>
                            <h5><span>PRODUCTS</span></h5>
                        </div>
                        <ul class="product">
                            <li>千极统一身份认证平台</li>
                            <li>千极共享办件系统</li>
                            <li>千极评价管理系统</li>
                            <li>千极电子票据系统</li>
                            <li>千极电子证照系统</li>
                            <li>千极数据交换平台</li>
                        </ul>
                    </div>
                    <div class="c h50"></div>
                     <div class="h50"></div>
                </div>
            </div>
            
        </div>
</template>
<script>
export default {
    mounted(){
        setTimeout(() => {
                // console.log($.isEmptyObject(this.$route.params))
                if(!$.isEmptyObject(this.$route.params)){
                    document.querySelector("#"+this.$route.params.id).scrollIntoView(true);  
                }
        }, 100);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/zwyth.vue